import { toast } from 'sonner';

/**
 * Copy text to clipboard with fallback for environments where Clipboard API is blocked
 * @param {string} text - Text to copy
 * @returns {Promise<boolean>} - Whether copy was successful
 */
export const copyToClipboard = async (text) => {
  try {
    // Try modern Clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
      return true;
    }
  } catch (err) {
    console.log('Clipboard API failed, trying fallback:', err.message);
  }

  // Fallback for environments where Clipboard API is blocked
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // Make the textarea invisible
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    textArea.style.opacity = '0';
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    const success = document.execCommand('copy');
    document.body.removeChild(textArea);
    
    if (success) {
      toast.success("Copied to clipboard!");
      return true;
    } else {
      throw new Error('execCommand copy failed');
    }
  } catch (err) {
    console.error('Fallback copy failed:', err);
    toast.error("Failed to copy. Please select and copy manually.");
    return false;
  }
};
